import { Helmet } from "react-helmet";

interface RouteMetaProps {
  title: string;
  description: string;
  path: string;
  noindex?: boolean;
}

/**
 * Per-route metadata helper. Renders unique title, meta description,
 * canonical, and Open Graph tags so each route has distinct SEO data.
 */
export function RouteMeta({ title, description, path, noindex }: RouteMetaProps) {
  const url = `https://financiallyfit.online${path}`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content="website" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
}
